export enum HoldingsMutationTypes {
  SET_CURRENCY_ACTIVE = 'SET_CURRENCY_ACTIVE',
  SET_ACCOUNT_TYPE_ACTIVE = 'SET_ACCOUNT_TYPE_ACTIVE',
  SET_MARKET_TYPE_ACTIVE = 'SET_MARKET_TYPE_ACTIVE',
  SET_FUND_ACC_MARKET_LIST = 'SET_FUND_ACC_MARKET_LIST',
  SET_STOCK_POS_PAGE_LIST = 'SET_STOCK_POS_PAGE_LIST',
  SET_OTHER_POS_PAGE_LIST = 'SET_OTHER_POS_PAGE_LIST',
  SET_BOND_POS_PAGE_LIST = 'SET_BOND_POS_PAGE_LIST',
  SET_FUND_POS_PAGE_LIST = 'SET_FUND_POS_PAGE_LIST',
  SET_SPS_POS_PAGE_LIST = 'SET_SPS_POS_PAGE_LIST',
  SET_CLIENT_LIFECYCLE = 'SET_CLIENT_LIFECYCLE',
  SET_IS_SHOW_ASSETS_DETAIL = 'SET_IS_SHOW_ASSETS_DETAIL',
  RESET_STATE = 'RESET_STATE'
}
